import React from "react";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import { Building2, Mail, Globe, FileText } from "lucide-react";

export default function Impressum() {
  return (
    <div
      style={{
        marginLeft: "240px",
        minHeight: "100vh",
        background: "linear-gradient(to bottom right, #f8f9fa, white)",
        padding: "2rem 0",
      }}
    >
      <Container>
        <div className="mb-4">
          <h1 className="display-5 fw-bold text-dark mb-2">Impressum</h1>
          <p className="text-muted">
            Informationen über den Diensteanbieter gemäß E-Commerce-Gesetz (ECG)
            und Mediengesetz
          </p>
        </div>

        <Card className="shadow-sm border-0 mb-4">
          <Card.Body className="p-4">
            <h2 className="h5 mb-4 d-flex align-items-center">
              <Building2 className="me-2" size={22} />
              Diensteanbieter
            </h2>

            <div className="row g-4">
              <div className="col-md-6">
                <h3 className="h6 text-muted mb-2">Firmenname</h3>
                <p className="mb-0">
                  <strong>FTG Finance Technologies GmbH</strong>
                </p>
              </div>

              <div className="col-md-6">
                <h3 className="h6 text-muted mb-2">Rechtsform</h3>
                <p className="mb-0">Gesellschaft mit beschränkter Haftung</p>
              </div>

              <div className="col-md-6">
                <h3 className="h6 text-muted mb-2">Geschäftsführer</h3>
                <p className="mb-0">Maximilian Hrebicek</p>
              </div>

              <div className="col-md-6">
                <h3 className="h6 text-muted mb-2">Firmensitz</h3>
                <p className="mb-0">
                  Börsegasse 9/8<br />
                  1010 Wien<br />
                  Österreich
                </p>
              </div>

              <div className="col-12">
                <hr className="my-3" />
              </div>

              <div className="col-md-6">
                <h3 className="h6 text-muted mb-2 d-flex align-items-center">
                  <Mail className="me-2" size={18} />
                  E-Mail
                </h3>
                <p className="mb-0">
                  <a
                    href="mailto:office@fintogo.ai"
                    className="text-decoration-none"
                  >
                    office@fintogo.ai
                  </a>
                </p>
              </div>

              <div className="col-md-6">
                <h3 className="h6 text-muted mb-2 d-flex align-items-center">
                  <Globe className="me-2" size={18} />
                  Website
                </h3>
                <p className="mb-0">
                  <a
                    href="https://www.fintogo.ai"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none"
                  >
                    www.fintogo.ai
                  </a>
                </p>
              </div>
            </div>
          </Card.Body>
        </Card>

        <Card className="shadow-sm border-0 mb-4">
          <Card.Body className="p-4">
            <h2 className="h5 mb-4 d-flex align-items-center">
              <FileText className="me-2" size={22} />
              Registerdaten
            </h2>

            <div className="row g-4">
              <div className="col-md-6">
                <h3 className="h6 text-muted mb-2">Firmenbuchnummer</h3>
                <p className="mb-0">FN 666615t</p>
              </div>

              <div className="col-md-6">
                <h3 className="h6 text-muted mb-2">Firmenbuchgericht</h3>
                <p className="mb-0">Handelsgericht Wien</p>
              </div>

              <div className="col-md-6">
                <h3 className="h6 text-muted mb-2">UID-Nummer</h3>
                <p className="mb-0">ATU82690802</p>
              </div>
            </div>
          </Card.Body>
        </Card>

        <Card className="shadow-sm border-0 mb-4">
          <Card.Body className="p-4">
            <h2 className="h5 mb-3">Unternehmensgegenstand</h2>
            <p className="mb-0">
              Erbringung von IT-Dienstleistungen aller Art Entwicklung und Betrieb von Online Service Plattformen Erbringung von Bildungsdienstleistungen Handel mit Waren aller Art
            </p>
          </Card.Body>
        </Card>

        <Card className="shadow-sm border-0 mb-4">
          <Card.Body className="p-4">
            <h2 className="h5 mb-3">Aufsichtsbehörde / Gewerbebehörde</h2>
            <p className="mb-1">
              <strong>Magistratisches Bezirksamt für den 1. Bezirk</strong>
            </p>
            <p className="mb-2">
              Börsegasse 11-13<br />
              1011 Wien<br />
              Österreich
            </p>
            <p className="mb-0">
              <a
                href="https://www.wien.gv.at"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
              >
                www.wien.gv.at
              </a>
            </p>
          </Card.Body>
        </Card>

        <Card className="shadow-sm border-0 mb-4">
          <Card.Body className="p-4">
            <h2 className="h5 mb-3">Mitgliedschaften</h2>
            <p className="mb-1">
              <strong>Wirtschaftskammer Wien</strong>
            </p>
            <p className="mb-2">
              Sparte Information und Consulting<br />
              Stubenring 8-10<br />
              1010 Wien
            </p>
            <p className="mb-0">
              <a
                href="https://www.wko.at"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
              >
                www.wko.at
              </a>
            </p>
          </Card.Body>
        </Card>

        <Card className="shadow-sm border-0 mb-4">
          <Card.Body className="p-4">
            <h2 className="h5 mb-3">Anwendbare Rechtsvorschriften</h2>
            <ul className="mb-0">
              <li>
                <a
                  href="https://www.ris.bka.gv.at"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  Gewerbeordnung (GewO)
                </a>
              </li>
              <li>
                <a
                  href="https://www.ris.bka.gv.at"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  Unternehmensgesetzbuch (UGB)
                </a>
              </li>
              <li>
                <a
                  href="https://www.ris.bka.gv.at"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  E-Commerce-Gesetz (ECG)
                </a>
              </li>
            </ul>
          </Card.Body>
        </Card>

        <Card className="shadow-sm border-0 mb-4">
          <Card.Body className="p-4">
            <h2 className="h5 mb-3">Online-Streitbeilegung (OS)</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:
            </p>
            <p>
              <a
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
              >
                https://ec.europa.eu/consumers/odr
              </a>
            </p>
            <p className="mb-0 small text-muted">
              Unsere E-Mail-Adresse:{" "}
              <a
                href="mailto:office@fintogo.ai"
                className="text-decoration-none"
              >
                office@fintogo.ai
              </a>
            </p>
          </Card.Body>
        </Card>

        <Card className="shadow-sm border-0 mb-4">
          <Card.Body className="p-4">
            <h2 className="h5 mb-3">Verbraucherstreitbeilegung</h2>
            <p className="mb-0">
              Wir sind nicht verpflichtet und nicht bereit, an
              Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
              teilzunehmen.
            </p>
          </Card.Body>
        </Card>

        <Card className="shadow-sm border-0 mb-4">
          <Card.Body className="p-4">
            <h2 className="h5 mb-3">Grundlegende Richtung der Website</h2>
            <p className="mb-0">
              Diese Website dient der Information über die fintogo Lernplattform
              und deren Dienstleistungen im Bereich digitale Finanz- und
              Wirtschaftsbildung. Die Plattform richtet sich an Schulen,
              Lehrkräfte, Schülerinnen und Schüler sowie Bildungseinrichtungen
              in Österreich und der EU.
            </p>
          </Card.Body>
        </Card>

        <Card className="shadow-sm border-0 mb-4">
          <Card.Body className="p-4">
            <h2 className="h5 mb-3">Urheberrecht</h2>
            <p className="mb-0">
              Die Inhalte dieser Website, einschließlich Texte, Grafiken, Logos,
              Bilder und Software, sind urheberrechtlich geschützt und Eigentum
              der FTG Finance Technologies GmbH oder ihrer Lizenzgeber. Die
              Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
              Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der
              schriftlichen Zustimmung des Autors bzw. Erstellers.
            </p>
          </Card.Body>
        </Card>

        <Card className="shadow-sm border-0 mb-4">
          <Card.Body className="p-4">
            <h2 className="h5 mb-3">Haftungsausschluss</h2>

            <h3 className="h6 mt-4 mb-2">Haftung für Inhalte</h3>
            <p>
              Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt.
              Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte
              können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter
              sind wir gemäß § 16 ECG für eigene Inhalte auf diesen Seiten nach
              den allgemeinen Gesetzen verantwortlich.
            </p>

            <h3 className="h6 mt-4 mb-2">Haftung für Links</h3>
            <p className="mb-0">
              Unser Angebot enthält Links zu externen Websites Dritter, auf
              deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
              diese fremden Inhalte auch keine Gewähr übernehmen. Für die
              Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
              oder Betreiber der Seiten verantwortlich.
            </p>
          </Card.Body>
        </Card>

        <Card className="shadow-sm border-0 mb-4">
          <Card.Body className="p-4">
            <h2 className="h5 mb-3">Bildnachweise</h2>
            <p className="mb-0">
              Alle auf dieser Website verwendeten Bilder und Grafiken sind
              Eigentum der FTG Finance Technologies GmbH oder werden mit
              entsprechenden Lizenzen verwendet. Spezifische Bildnachweise werden
              bei Bedarf direkt bei den jeweiligen Bildern angegeben.
            </p>
          </Card.Body>
        </Card>

        <Card className="shadow-sm border-0">
          <Card.Body className="p-4">
            <h2 className="h5 mb-3">Kontakt für rechtliche Anfragen</h2>
            <p className="mb-0">
              Für rechtliche Anfragen, Beschwerden oder Hinweise zu
              Urheberrechtsverletzungen wenden Sie sich bitte an:{" "}
              <a
                href="mailto:office@fintogo.ai"
                className="text-decoration-none"
              >
                office@fintogo.ai
              </a>
            </p>
          </Card.Body>
        </Card>

        <p className="text-center text-muted small mt-4">
          Stand: 30. November 2025
          <br />
          Dieses Impressum erfüllt die Anforderungen des Mediengesetzes
          (MedienG), der E-Commerce-Richtlinie (ECG), des
          Unternehmensgesetzbuches (UGB) sowie der Gewerbeordnung (GewO) in
          Österreich.
        </p>
      </Container>
    </div>
  );
}
